import React, { useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAxios } from '../../hooks/useAxios';
import { useEnter } from '../../hooks/useEnter';
import { FooterError } from '../../ui/errors/FooterError';
import { Loader } from '../../ui/loaders/Loader';
import { FooterSuccess } from '../../ui/success/FooterSuccess';

export const ResetPassword = () => {
  const api = useAxios()
  const navigate = useNavigate()
  const {token,email} = useParams()
  const [password,setPassword] = useState()
  const [passwordConfirmation,setPasswordConfirmation] = useState()
  const [loading,setLoading] = useState(false)
  const [errors,setErrors] = useState()
  const [success,setSuccess] = useState()
  const resetPassword = async ()=> {
    console.log(email)
    setLoading(true)
    setErrors()
    setSuccess()
    try{
      const response = await api.post('reset-password',{password,password_confirmation:passwordConfirmation,token,email})

      setSuccess('Your password updated')
    }catch(ex){
      setErrors(ex?.response?.data?.errors)
    }finally{
      setLoading(false)
    }
  }
  useEnter(resetPassword)
  return (
		<div className="container position-relative">
			<div className="w-50 mx-auto mt-5 card shadow">
				<div className="card-header fw-bold ">{process.env.REACT_APP_APP_NAME} Guardian Password Reset</div>
				<div className="card-body">
					<div className="form-group">
						<label className="form-label">New Password</label>
						<input
							type={`password`}
							className="form-control"
							onChange={(e) => setPassword(e.target.value)}
						/>
					</div>
					<div className="form-group">
						<label className="form-label">Confirm New Password</label>
						<input
							type={`password`}
							className="form-control"
							onChange={(e) => setPasswordConfirmation(e.target.value)}
						/>
					</div>
				</div>
				<div className="card-footer d-flex align-items-center justify-content-between">
					<div>
						{loading && (
							<Loader
								message={"Please wait"}
							/>
						)}
            {errors?.password && <FooterError error={errors?.password} />}
            {errors?.invalid_token && <><FooterError error={errors?.invalid_token} />
              
            </>}
            {success && <FooterSuccess success={success} />}
					</div>
          
					<div className='btn-group'>
						<button onClick={resetPassword} className='btn btn-primary'>Reset Password</button>
            {success && <button className='btn btn-success' onClick={()=>navigate('/login')}>Login</button>}
            {errors?.invalid_token && <button className='btn btn-danger' onClick={()=>navigate('/forgot-password')}>Request new link</button>}
					</div>
					
				</div>
			</div>
		</div>
	);
}
